import { FC, ReactNode } from 'react'
import { Icon, Tooltip } from 'antd'

type InfoTooltipButtonProps = {
  title: ReactNode
}

const InfoTooltipButton: FC<InfoTooltipButtonProps> = ({ title }) => (
  <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{title}</span>}>
    <Icon type="info-circle" style={{ fontSize: 15, color: '#AAAAAA' }} />
  </Tooltip>
)

export default InfoTooltipButton
